"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BonusConditions = function (_a) {
    var onClose = _a.onClose, children = _a.children, promoCode = _a.promoCode;
    var t = (0, next_intl_1.useTranslations)('translation');
    var openDepositWithPromoCode = (0, apps_shared_1.useOpenDepositWithPromoCode)(promoCode);
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var config = (0, swr_hooks_1.useConfig)();
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "538px", onClose: onClose },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("h1", null, t('conditions')),
            children,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", maxWidth: "320px", onClick: isAuth ? openDepositWithPromoCode : openSignUp }, t('deposit')),
                react_1.default.createElement("a", { href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.generalTermsAndConditionsLink) || '/terms-of-use'), className: styles_module_scss_1.default.link, target: "_blank" }, t('generalTermsAndConditions'))))));
};
exports.default = BonusConditions;
